import { render, staticRenderFns } from "./WDQuoteStatusBadge.vue?vue&type=template&id=3c605e78&"
import script from "./WDQuoteStatusBadge.vue?vue&type=script&lang=js&"
export * from "./WDQuoteStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports